<template>
    <form class="flex items-center space-x-4" @submit.prevent="submit">

        <Input
            name="email"
            type="email"
            placeholder="Email"
            v-model="form.email"
            required
            autofocus
            autocomplete="email"/>

        <Input
            name="password"
            type="password"
            placeholder="Password"
            v-model="form.password"
            required
            autocomplete="current-password"/>

        <SubmitButton
            class="h-full"
            :submitting="form.processing"
            :disabled="form.errors.any()">
            Login
        </SubmitButton>
    </form>
</template>

<script>

import Login from "@/Components/Auth/LoginForm.vue"
import {computed} from "vue";

export default {

    name: "InlineLoginForm",

    extends: Login,

    provide() {
        return {
            hasError: computed(() => !!this.form.errors.any())
        };
    }
};

</script>
